var React = require('react');

function ArrowRightBig (props) {
    return React.createElement("svg",props,React.createElement("path",{"id":"Path_665","data-name":"Path 665","d":"M-7537.826-10887.471l8,8-8,8","transform":"translate(7538.533 10888.178)","fill":"none","stroke":"#363d4a","strokeWidth":"2"}));
}

ArrowRightBig.defaultProps = {"width":"10.121","height":"17.414","viewBox":"0 0 10.121 17.414"};

module.exports = ArrowRightBig;

ArrowRightBig.default = ArrowRightBig;
